import LoginImage from '@/assets/images/LoginImage.svg';

export function PartnerViewerSignupSuccess() {
  return (
    <div className="min-h-screen bg-highlight flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col items-center mb-8">
        <img src={LoginImage} alt="Culture Monitor" className="w-44" />
      </div>
      <div className="bg-white rounded-2xl shadow-sm p-10 w-full sm:w-[28rem]">
        <h1 className="text-xl font-bold text-gray-900 mb-4">
          Prontinho :)
        </h1>
        <p className="text-sm text-gray-900 leading-relaxed">
          Seu cadastro foi confirmado com sucesso. Agora, é só aguardar os reports fresquinhos no
          seu e{'\u2011'}mail.
        </p>
      </div>
    </div>
  );
}
